export const ASSET_STATUS_MAX_END_TIME = new Date(9999, 0, 1)
